/**
 * PreviewCard component is used to display values entered
 * in personalization form for selected products
 */
import InfoCard from '@zola/zola-ui/src/components/Card/InfoCard/InfoCard';
import { Link } from '@zola/zola-ui/src/components/Link';

import PropTypes from 'prop-types';

import './PreviewCard.less';

const renderInputValues = (label, inputValue) => (
  <div key={label} className="personalization-card__item">
    <span className="personalization-card__choice">
      <h6 className="text-uppercase">{label}:</h6>
      {inputValue}
    </span>
  </div>
);

const renderStep = (step) => (
  <div key={step.personalization_display_name} className="personalization-card__step">
    {step.selected_options.map((o) => renderInputValues(o.display_name, o.selected_value))}
  </div>
);

const PreviewCard = ({ onEdit, onRemove, personalizationOptions, personalizations }) => {
  const hasActions = onEdit && onRemove;
  return (
    <div className="personalization-card">
      <InfoCard>
        <>
          {personalizations && personalizations.personalizations.map((p) => renderStep(p))}
          {personalizationOptions &&
            personalizationOptions.map((o) => renderInputValues(o.display_name, o.selected_value))}
          {hasActions && (
            <div className="personalization-card__actions">
              <Link href="" onClick={onEdit}>
                Edit
              </Link>
              <div className="personalization-card__action-divider" />
              <Link href="" onClick={onRemove}>
                Remove
              </Link>
            </div>
          )}
        </>
      </InfoCard>
    </div>
  );
};

PreviewCard.propTypes = {
  personalizationOptions: PropTypes.arrayOf(PropTypes.shape({})),
  personalizations: PropTypes.shape({}),
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
};

export default PreviewCard;
